<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_hardSoftConsonants') }}
        game-preview-setting(v-if="parameters.amountOfExamples && !parameters.timeLimit")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_examples') }}
            span(slot="value") {{ parameters.amountOfExamples }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_difficultyLevel') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSetting_' +  parameters.theme)  }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_transcription') }}
            span(slot="value") {{  parameters.isTranscriptionEnabled ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf') }}

</template>

<script>
/*eslint-disable*/
import GamePreviewSettings from './GamePreviewSettings.vue'
import GamePreviewSetting from './GamePreviewSetting.vue'
import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin'

export default {
    props: ['parameters', 'exerciseId', 'type'],
    mixins: [GamePreviewMixin],
    components: {
        GamePreviewSettings,
        GamePreviewSetting
    },
}
</script>
